
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({ default: 'btn-primary' })
  private classic!: string;

  @Prop({ default: 'button' })
  private text!: string;

  @Prop()
  private icon!: string;

  @Prop({ default: 'left' })
  private iconSide!: string;

}
